import React from 'react';
import {  calculateHourDifference, calculatePackageAmount, CurrencySymbol, defaultDropOffDate, defaultDropOffTime, defaultPickUpDate, defaultPickUpTime, getDrivingLimit } from '../../functionsMaster';
import PropTypes from 'prop-types';

const CarPackagesSelect = ({
    carID = 0,
    carPackages = [],
    carPackagPricing = [],
    selectedPackage = "0",
    pickUpDate = defaultPickUpDate(),
    pickUpTime = defaultPickUpTime(),
    dropOffDate = defaultDropOffDate(),
    dropOffTime = defaultDropOffTime(),
    setSelectedPackage = (v = '') => { console.error(`No setSelectedPackage Function in CarPackagesSelect ${v}`); },
    setSelectedPackageData = (v = '') => { console.error(`No setSelectedPackage Function in CarPackagesSelect ${v}`); },
}) => {
    
      // const [pickUpDate] = useState(defaultPickUpDate());
      // const [pickUpTime] = useState(defaultPickUpTime());
      // const [dropOffDate] = useState(defaultDropOffDate());
      // const [dropOffTime] = useState(defaultDropOffTime());


  function theHoures() {
      const theHours = calculateHourDifference(pickUpDate, pickUpTime, dropOffDate, dropOffTime);
      if (theHours) {
        return Number(theHours);
      } else {
        return 12;
      }
}   

  return (
          <>

        

            {carPackagPricing && carPackagPricing.length > 0 && carPackagPricing.map((s) => (
                <>
                  {s && s.pkgID && (
                    <label key={s.pkgID} className="booking_custom_check bookin-check-2">
                      <input
                          type="radio"
                          name={`price_rate${carID}`}
                          value={s && s.pkgID ? s.pkgID : ''}
                          defaultChecked={s && s.pkgID === selectedPackage}
                          onChange={(e) => {
                            if (e.target.checked) {
                              const pkgID = e.target.value;
                              if (pkgID) {
                                setSelectedPackage(pkgID);
                                const result = carPackagPricing.find((item) => item.pkgID === pkgID);
                                if (result) {
                                  setSelectedPackageData(result);
                                }
                                localStorage.setItem('pkgID', pkgID);
                              }
                            }
                          }}
                      />
                      <span className="booking_checkmark text-warning">
                          <span className="checked-title">
                          <b>{getDrivingLimit(carPackages, s.pkgID, 'distance', theHoures(), true)} KM Driving Limit </b> (Extra KM at ₹{s.extraKMRate})
                          </span>
                          <span className="price-rate">
                          {CurrencySymbol} {calculatePackageAmount(s, theHoures(), true)}
                          </span>
                      </span>
                    </label>
                  )}
                </>
            ))}
          </>
  );
};

CarPackagesSelect.propTypes = {
    carPackages: PropTypes.any.isRequired,
    carPackagPricing: PropTypes.any.isRequired,
    carID: PropTypes.any,
    pickUpDate: PropTypes.any,
    pickUpTime: PropTypes.any,
    dropOffDate: PropTypes.any,
    dropOffTime: PropTypes.any,
    selectedPackage: PropTypes.any.isRequired,
    setSelectedPackage: PropTypes.any.isRequired,
    setSelectedPackageData: PropTypes.any.isRequired,
};

export default CarPackagesSelect;
